import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { useListenLocalStorage } from './localStorage'

import '../locales/i18n'

export const useListenTranslate = (): void => {
  const { i18n } = useTranslation()
  const localValues = useListenLocalStorage(['locale'])

  useEffect(() => {
    if (i18n.language === localValues.locale) return
    i18n.changeLanguage(localValues.locale)
  }, [localValues.locale])
}
